import React, { useEffect, useState } from 'react';
import { DropdownButton, FormControl, MenuItem } from 'react-bootstrap';
import { useDebounce } from '../../hooks/useDebounce.js';
import styles from './NumberOfPeopleFilter.module.css';

const inputCustomStyle = {
  height: '28px',
  margin: '3px 0 3px 4px',
  paddingRight: '2px',
};

const dropdownCustomStyle = {
  padding: '15px',
  background: '#fff',
  border: 'none',
};

const values = ['1-25', '26-50', '51-75', '76-100', '101-1000'];

function NumberOfPeopleFilter({ peopleImpacted, navigateAction }) {
  const [isMounted, setIsMounted] = useState(false);

  const [min, setMin] = useState('');
  const [max, setMax] = useState('');

  const debouncedMin = useDebounce(min, 500);
  const debouncedMax = useDebounce(max, 500);

  const handleChangeMin = (event) => setMin(event.target.value);
  const handleChangeMax = (event) => setMax(event.target.value);

  const handleSelect = (value) => {
    setMin(value.split('-')[0]);
    setMax(value.split('-')[1]);

    peopleImpacted = value;
    navigateAction({ peopleImpacted });
  };

  const updateMinFilter = (value) => {
    if (value) {
      peopleImpacted = max ? `${value}-${max}` : value;
    } else peopleImpacted = max ? `0-${max}` : '0';

    peopleImpacted === '0' ? (peopleImpacted = '') : null;
    isMounted && navigateAction({ peopleImpacted });
  };

  const updateMaxFilter = (value) => {
    if (value) {
      peopleImpacted = min ? `${min}-${value}` : `0-${value}`;
    } else peopleImpacted = min || '0';

    peopleImpacted === '0' ? (peopleImpacted = '') : null;
    isMounted && navigateAction({ peopleImpacted });
  };

  const handleReset = () => {
    peopleImpacted = '';
    navigateAction({ peopleImpacted });
  };

  useEffect(() => {
    if (peopleImpacted) {
      if (/-/.test(peopleImpacted)) {
        setMin(peopleImpacted.split('-')[0]);
        setMax(peopleImpacted.split('-')[1]);
      } else {
        setMin(peopleImpacted.split('-')[0]);
        setMax('');
      }
    }

    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!peopleImpacted) {
      setMin('');
      setMax('');
    }
    // clear value after filter reset
  }, [peopleImpacted]);

  useEffect(() => {
    isMounted && updateMinFilter(debouncedMin);
  }, [debouncedMin]);

  useEffect(() => {
    isMounted && updateMaxFilter(debouncedMax);
  }, [debouncedMax]);

  return (
    <div className={`report-filter ${styles.reportFilter}`}>
      <div className="text-muted filter-label">Number of People Impacted</div>
      <div className={`flex ${styles.rangeInputGroup}`}>
        <FormControl
          className="range-input"
          placeholder="From"
          type="number"
          style={inputCustomStyle}
          value={min}
          onChange={handleChangeMin}
        />
        <FormControl
          className="range-input"
          placeholder="To"
          type="number"
          style={inputCustomStyle}
          value={max}
          onChange={handleChangeMax}
        />
        <DropdownButton
          bsStyle="info"
          id="people-range"
          title=""
          style={dropdownCustomStyle}
        >
          <MenuItem onSelect={handleReset}>All</MenuItem>

          {values.map((range) => (
            <MenuItem
              key={range}
              eventKey={range}
              active={peopleImpacted === range}
              onSelect={handleSelect}
            >
              {range}
            </MenuItem>
          ))}
        </DropdownButton>
      </div>
    </div>
  );
}

export default NumberOfPeopleFilter;
